import { Image } from '../../types/Image';

export interface UapiEvent {
  id: string;
  name: string;
  description: string;
  code: string;
  startDate: string;
  endDate: string;
  externalId: string;
  createdAt: string;
  configuration: {
    timezone: string;
    isLeadCaptureEnabled: boolean;
  };
  eventIcon: Image;
  theme: {
    contentBackgroundColor: string;
    contentTextColor: string;
    linkTextColor: string;
    loginBackgroundColor: string;
    loginBackgroundImageUrl: string;
    menuBackgroundColor: string;
    menuTextColor: string;
  };
  crmEventId: string;
}

export interface CmsEvent {
  id: number;
  organization_id: string;
  shortcode: string;
  event_directory: string;
  event_type: string;
  event_website: string;
  location_name: string;
  location_address: string;
  description: string;
  name: string;
  creation_date: string;
  start_date: string;
  end_date: string;
  use_high_build: boolean;
  use_cache: boolean;
  cache_revision: number;
  header_images: string[];
  icon_color: string;
  package_id: number;
  partner_id: number;
  support_email_address: string | null;
  outbound_email_address: string | null;
  is_cms2_event: boolean;
  is_registration_enabled: boolean;
  is_trial: boolean;
  is_trial_expired: boolean;
  modern_privacy_model: boolean;
  time_format: string;
  timezone: string;
  use_custom_outbound_email_address: boolean;
  language: string;
  language_tag: string;
  per_person_limit: number;
  alternative_languages: string[];
  alternative_language_tags: string[];
  multilingual_eventapp: boolean;
  desktop_widget_page_id: string;
  event_format: string;
  event_icon_image_id: string | null;
  custom_domain_enabled: boolean;
  custom_domain_name: string | null;
  custom_domain_status: string | null;
}

export interface BasicDataEvent {
  appIconUrl: string;
  eventId: 8024;
  eventName: string;
  eventTimezone: string;
}

export enum Theme {
  defaultContentBackgroundColor = '#fafafa',
  defaultContentTextColor = '#444444',
  defaultLinkTextColor = '#e65529',
  defaultMenuBackgroundColor = '#656f81',
  defaultMenuTextColor = '#ffffff',
}
